// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Breadcrumbs.module.scss  */
.Breadcrumbs-module-Root_SHl {
  font-family: var(--control-font-family); }

.Breadcrumbs-module-List_1HW {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 0;
  list-style: none; }

.Breadcrumbs-module-List_1HW .Breadcrumbs-module-List_1HW {
  display: block;
  padding-left: 0;
  list-style: none; }
  .Breadcrumbs-module-List_1HW .Breadcrumbs-module-List_1HW a {
    line-height: 2;
    text-transform: unset; }

.Breadcrumbs-module-Popup_2SX {
  overflow-y: auto;
  max-width: 200px;
  max-height: 200px; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Breadcrumbs/Breadcrumbs.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,uCAAuC,EAAE;;AAE3C;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE;;AAEpB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB,EAAE;EAClB;IACE,cAAc;IACd,qBAAqB,EAAE;;AAE3B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB,EAAE","sourcesContent":["/*  imported from Breadcrumbs.module.scss  */\n.Breadcrumbs-module-Root_SHl {\n  font-family: var(--control-font-family); }\n\n.Breadcrumbs-module-List_1HW {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none; }\n\n.Breadcrumbs-module-List_1HW .Breadcrumbs-module-List_1HW {\n  display: block;\n  padding-left: 0;\n  list-style: none; }\n  .Breadcrumbs-module-List_1HW .Breadcrumbs-module-List_1HW a {\n    line-height: 2;\n    text-transform: unset; }\n\n.Breadcrumbs-module-Popup_2SX {\n  overflow-y: auto;\n  max-width: 200px;\n  max-height: 200px; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
